import React from 'react'

import "./Swap.css";
import Logo from '../../assets/logo/logo.png';
import Bnb from '../../assets/logo/bnb.png';
import Down from '../../assets/icons/down-arrow.png';
import Updown from '../../assets/icons/updown.png';
import Button from '../../components/UnlockWallet';
import { useState } from 'react';
import  Setting  from '../../assets/logo/setting.png';
import Wallet from '../../assets/icons/wallet.png';


const Swap: React.FC = () => {
  const[switchToggled, setelement]=useState(false)
  const ToggleSwitch=()=>{switchToggled ? setelement(false):setelement(true);
    
  }
  

  return (
    <div>
      <div className='swap-container'>
       
      <h1 className='swipe'>Swap</h1>
      <img className='setting' src={Setting}/>
      <img className='wallet' src={Wallet}/>
      
        <div className='swap-parent'>
          
          <div className={switchToggled?"swap-first-toggle":"swap-firsthalf"}>
            <div className='firsthalf-header'>
              <span  id='from'>From</span>
              <span id='balance'>Balance:(wallet not recommened)</span>
            </div>
            <div className='firsthalf-footer'>
              <span id='chx'> CHX </span>
              <img id='logo' src={Logo} alt="logo"></img>
              
              <div className='line'></div>
              <span id='max-first'> Max</span>
              <span id='half-first'> Half</span>

            </div>
            <img id ='arrow'  src={Down}
              ></img>
          </div>
          <div className='smallimage'><img id='updown' src={Updown}
          onClick={ToggleSwitch}
          ></img></div>
          <br></br>
          
          <div className={switchToggled?"swap-second-toggle":"swap-secondhalf"}>
            <div className='secondhalf-header'>
              <span  id='to'>To</span>
              <span id='balance'>Balance:(wallet not recommened)</span>
            </div>
            <div className='secondhalf-footer'>
              <span id='bnbfont' > BNB </span>
              <img id='bnb' src={Bnb} alt="logo"></img>
              <img id ='arrow' src={Down} ></img>
              <div className='line'></div>
              <span id='max-second'> Max</span>
              <span id='half-second'> Half</span>

            </div>
          </div>
          <div className='swap-thirdhalf'>
            <button><Button/> 
            </button></div>
         
        </div>
        
      </div>

    </div>

  )
};

export default Swap;